export const DEFAULT_PRODUCT_DATA_VALUE = {
  products: null,
  productsLen: '',
  productsMinDia: '',
  productsPercent: 0,
  productsDestination: null,
  productsPricePerTonne: 0,
  price: 0,
};

export const DEFAULT_SPECIES_DATA_VALUE = {
  species: null,
  areaInHa: 0,
  percentageOfSite: 0,
};
